import { render, staticRenderFns } from "./GeneAssociationsTable.vue?vue&type=template&id=64c3c4c7&"
import script from "./GeneAssociationsTable.vue?vue&type=script&lang=js&"
export * from "./GeneAssociationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c3c4c7')) {
      api.createRecord('64c3c4c7', component.options)
    } else {
      api.reload('64c3c4c7', component.options)
    }
    module.hot.accept("./GeneAssociationsTable.vue?vue&type=template&id=64c3c4c7&", function () {
      api.rerender('64c3c4c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GeneAssociationsTable.vue"
export default component.exports